import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_tablet-layout/branch/$id/create/_wizard/success')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/branch/$id/create/submit', params })
    },
})
